var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M3.375 3.375V4.5H7.125V3.375C7.125 2.34375 6.28125 1.5 5.25 1.5C4.19531 1.5 3.375 2.34375 3.375 3.375ZM1.875 4.5V3.375C1.875 1.52344 3.375 0 5.25 0C7.10156 0 8.625 1.52344 8.625 3.375V4.5H9C9.82031 4.5 10.5 5.17969 10.5 6V10.5C10.5 11.3438 9.82031 12 9 12H1.5C0.65625 12 0 11.3438 0 10.5V6C0 5.17969 0.65625 4.5 1.5 4.5H1.875Z",
    fill: "#944FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/lock2.8c078d123097d76468cda4b1be19eb34.svg";
export { ForwardRef as ReactComponent };